import {
	Card,
	Divider,
	Pagination,
	Button,
	Modal,
	Input,
	Select,
	Tag,
} from 'antd';
import { useEffect, useState } from 'react';
import { useParams, Link, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import SearchFilter from '../../component/Filter';
import { getUserProfileById } from '../../methods/redux/reducers/user-profile';
import remakeQueryString from '../../methods/utils/remake-query-string';
import {
	banUserInvestment,
	createProxyInvestment,
	investmentStatusCount,
	retrieveInvestmentItems,
	startProxyInvestment,
} from '../../methods/redux/reducers/investment';
import InvestmentList from './InvestmentLists';
import { getCurrencies } from '../../methods/redux/reducers/currency';
// import InvestmentStatusCount from './InvestmentStatusCounts';
import InvestmentStatusCount from './InvestmentStatusCounts';
import NativeNumber from '../../component/Numeral';
import { retrieveInternalSettings } from '../../methods/redux/reducers/internal-settings';

const Style = styled.div`
	& .mini-report {
		& > * {
			display: inline-block;
			margin-right: 10px;
			margin-bottom: 10px;
		}
		& .amount {
			font-weight: 600;
			font-size: 16px;

			&.red {
				color: var(--red-color);
			}
		}
	}

	& .out-links {
		display: inline-block;
		margin-right: 20px;
		text-decoration: underline;
	}
`;

const Investment = () => {
	const dispatch = useAppDispatch();
	const { userId } = useParams();

	const [visible, setVisible] = useState(false);
	const [visibleCreateInvestment, setVisibleCreateInvestment] = useState(false);

	const [searchParams, setSearchParams] = useSearchParams();

	const { investmentItems, investmentStatus } = useAppSelector(
		(store) => store.investment
	);
	const settings = useAppSelector((store) => store.internalSettings);

	const { currencies } = useAppSelector((store) => store.currencies);
	const { user } = useAppSelector((store) => store.userProfile);
	const [state, setState] = useState({
		bvn: '',
		memberId: userId,
	});

	const [createState, setCreateState] = useState({
		investmentForm: '',
		memberId: userId,
		durationInMonth: '',
		title: '',
		reInvestAfterMaturity: false,
		amount: 0,
		currencyId: '',
	});
	const [isInvestmentProfile, setIsInvestmentProfile] = useState(false);
	const startInvestmentStatus = user?.profile?.useInvestment;
	const riseVestInvestorId = user?.profile?.riseVestInvestorId;
	const [isStartInvestment, setIsStartInvestment] = useState(
		startInvestmentStatus
	);

	const [isHasRisevestId, setisHasRisevestId] = useState(false);
	const submit = () => {
		dispatch(startProxyInvestment({ ...state }));
		setVisible(false);
	};

	const submitCreateInvestment = () => {
		dispatch(createProxyInvestment({ ...createState }));
		setVisibleCreateInvestment(false);
	};

	const investForm = [
		{
			key: 'REAL_ESTATE',
			label: 'REAL_ESTATE',
		},
		{
			key: 'STOCKS',
			label: 'STOCKS',
		},
	];

	const reInvest = [
		{
			key: 'true',
			label: 'true',
		},
		{
			key: 'false',
			label: 'false',
		},
	];

	const duration = [
		{
			key: 3,
			label: 3,
		},
		{
			key: 6,
			label: 6,
		},
		{
			key: 12,
			label: 12,
		},
	];

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length === 0) {
			setSearchParams({
				status: 'active',
				pageId: '1',
				perPage: String(investmentItems.paginator.perPage),
			});
		}

		if (userId) {
			dispatch(getUserProfileById(userId));
		}
		if (riseVestInvestorId) {
			setIsInvestmentProfile(true);
			setisHasRisevestId(true);
		}
		dispatch(retrieveInvestmentItems({ ...queryData, memberId: userId }));
		dispatch(getCurrencies({}));
		dispatch(investmentStatusCount({ memberId: userId }));
		dispatch(retrieveInternalSettings());
	}, []);

	useEffect(() => {
		if (userId) {
			dispatch(getUserProfileById(userId));
		}
	}, [userId]);

	useEffect(() => {
		setIsStartInvestment(startInvestmentStatus);
	}, [startInvestmentStatus]);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};
	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length > 0) {
			if (userId) {
				dispatch(retrieveInvestmentItems({ ...queryData, memberId: userId }));
			}
		}
	}, [searchParams]);
	const submitBan = () => {
		dispatch(banUserInvestment({ memberId: userId }));
	};

	const investmentFormSelect = [
		{
			name: 'REAL_ESTATE',
			value: 'REAL_ESTATE',
		},
		{
			name: 'STOCK',
			value: 'STOCK',
		},
	];

	return (
		<Style>
			<Card>
				<h1>
					Investment Profile{' '}
					{userId && (
						<span>
							for{' '}
							<Link to={`/user-profile/${user.profile?._id}`}>
								@{user.profile?.username}
							</Link>
						</span>
					)}
				</h1>
				<p>
					<strong>Investment Signup Date: </strong>
					{moment(user.profile.investmentSignUpDate).format(
						'MMM DD, YY / hh:mm:ss a'
					)}
				</p>
				<div
					className="lined-settings"
					// style={{ display: 'flex', justifyContent: 'flex-end' }}
				>
					<div style={{ marginTop: '20px' }}>
						<Button type="primary" onClick={() => submitBan()}>
							{user.profile.allowInvestments
								? 'Ban user Investment'
								: 'Unban user investment'}
						</Button>
					</div>
				</div>
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
					}}
				>
					<div style={{ marginRight: '10px' }}>
						{!user.profile.kycLevelTwoStatus ||
						user.profile.kycLevelTwoStatus === '' ||
						user.profile.kycLevelTwoStatus === 'pending' ||
						user.profile.phoneNo === '' ? (
							<Button disabled>Start Investment</Button>
						) : (
							<Button
								disabled={
									startInvestmentStatus === true && riseVestInvestorId !== null
								}
								type="primary"
								onClick={() => setVisible(true)}
							>
								{startInvestmentStatus === true && riseVestInvestorId === null
									? 'Register Investment'
									: 'Start Investment'}
							</Button>
						)}
					</div>

					<div>
						<Button
							disabled={
								(isStartInvestment === true && riseVestInvestorId === null) ||
								(isStartInvestment === false && riseVestInvestorId === null)
							}
							type="primary"
							onClick={() => setVisibleCreateInvestment(true)}
						>
							Create Investment
						</Button>
					</div>
				</div>

				{!user.profile.kycLevelTwoStatus ||
				user.profile.kycLevelTwoStatus === '' ||
				user.profile.kycLevelTwoStatus === 'pending' ||
				user.profile.phoneNo === '' ? (
					<p style={{ color: 'red' }}>
						Please Update phone number and kyc before proceed with investement.
					</p>
				) : null}
				<Divider />

				<div className="mini-report">
					<Tag
						color="black"
						style={{
							padding: '7px 15px',
							marginRight: '10px',
							marginBottom: '10px',
						}}
					>
						<p>Total</p>
						<p>
							<NativeNumber value={investmentItems?.paginator?.itemCount} />
						</p>
					</Tag>
					{/* <Card>
						<p className="amount red">{investmentItems.paginator?.itemCount}</p>
						<p>Total User Investment Count</p>
					</Card> */}
					<InvestmentStatusCount statusCount={investmentStatus} />
				</div>
				<Divider />

				{isHasRisevestId && isInvestmentProfile === true ? (
					<div className="mini-report">
						<Card
							style={{
								boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
								padding: '20px',
							}}
						>
							<h2>Investment Profile</h2>
							<table style={{ width: '100%', borderCollapse: 'collapse' }}>
								<tbody>
									<tr>
										<td
											style={{
												fontWeight: 'bold',
												padding: '8px',
												borderBottom: '1px solid #ddd',
											}}
										>
											Email:
										</td>
										<td
											style={{ padding: '8px', borderBottom: '1px solid #ddd' }}
										>
											{user.profile?.investorProfile?.email}
										</td>
									</tr>
									<tr>
										<td
											style={{
												fontWeight: 'bold',
												padding: '8px',
												borderBottom: '1px solid #ddd',
											}}
										>
											Status:
										</td>
										<td
											style={{ padding: '8px', borderBottom: '1px solid #ddd' }}
										>
											{user.profile?.investorProfile?.status}
										</td>
									</tr>
									<tr>
										<td
											style={{
												fontWeight: 'bold',
												padding: '8px',
												borderBottom: '1px solid #ddd',
											}}
										>
											First Name:
										</td>
										<td
											style={{ padding: '8px', borderBottom: '1px solid #ddd' }}
										>
											{user.profile?.investorProfile?.firstName}
										</td>
									</tr>
									<tr>
										<td
											style={{
												fontWeight: 'bold',
												padding: '8px',
												borderBottom: '1px solid #ddd',
											}}
										>
											Last Name:
										</td>
										<td
											style={{ padding: '8px', borderBottom: '1px solid #ddd' }}
										>
											{user.profile?.investorProfile?.lastName}
										</td>
									</tr>

									<tr>
										<td
											style={{
												fontWeight: 'bold',
												padding: '8px',
												borderBottom: '1px solid #ddd',
											}}
										>
											Account Email:
										</td>
										<td
											style={{ padding: '8px', borderBottom: '1px solid #ddd' }}
										>
											{user.profile?.investorProfile?.accountEmail}
										</td>
									</tr>
									<tr>
										<td
											style={{
												fontWeight: 'bold',
												padding: '8px',
												borderBottom: '1px solid #ddd',
											}}
										>
											Account Type:
										</td>
										<td
											style={{ padding: '8px', borderBottom: '1px solid #ddd' }}
										>
											{user.profile?.investorProfile?.accountType}
										</td>
									</tr>
									<tr>
										<td
											style={{
												fontWeight: 'bold',
												padding: '8px',
												borderBottom: '1px solid #ddd',
											}}
										>
											Customer Id:
										</td>
										<td
											style={{ padding: '8px', borderBottom: '1px solid #ddd' }}
										>
											{user.profile?.investorProfile?.customerId}
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</div>
				) : null}

				<br />

				{/* <div>
					<Link className="out-links" to="/settings/investment-settings">
						Settings
					</Link>
				</div> */}

				<Divider />
				<SearchFilter
					title="Search Investment"
					searchFilters={[
						{
							label: 'investmentStatus',
							name: 'investmentStatus',
							defaultSelectedValue: 'running',
							htmlElement: 'select',
							selectOptions: [
								{ name: 'running', value: 'running' },
								{ name: 'Completed', value: 'completed' },
								{ name: 'terminated', value: 'terminated' },
								{ name: 'liquidated', value: 'liquidated' },
							],
						},
						{
							label: 'investmentForm',
							name: 'investmentForm',
							htmlElement: 'select',
							selectOptions: investmentFormSelect,
						},
						{
							label: 'status',
							name: 'status',
							defaultSelectedValue: 'active',
							htmlElement: 'select',
							selectOptions: [
								{ name: 'active', value: 'active' },
								{ name: 'pending', value: 'pending' },
								{ name: 'deleted', value: 'deleted' },
							],
						},
					]}
					retrieveQueryString={updateQueryString}
				/>

				<br />

				<p>
					Total of <strong>{investmentItems.paginator?.itemCount} items</strong>{' '}
					found
				</p>
				<Divider />

				<div>
					<Pagination
						onChange={(pageId) => updateQueryString({ pageId })}
						total={investmentItems?.paginator?.itemCount}
						current={investmentItems?.paginator?.currentPage}
						pageSize={investmentItems?.paginator?.perPage ?? 20}
					/>
				</div>

				<br />

				{investmentItems &&
					investmentItems.itemsList.map((index: any) => (
						<InvestmentList
							key={index._id}
							investmentProfile={{ ...index, name: user.profile?.fullName }}
						/>
					))}

				<br />

				<Pagination
					onChange={(pageId) => updateQueryString({ pageId })}
					total={investmentItems?.paginator?.itemCount}
					current={investmentItems?.paginator?.currentPage}
					pageSize={investmentItems?.paginator?.perPage ?? 20}
					showSizeChanger
					showQuickJumper
				/>
			</Card>
			<Modal
				okText="Start Investment"
				title="Start Investment"
				onOk={submit}
				visible={visible}
				onCancel={() => setVisible(false)}
			>
				<p>Bvn Number</p>
				<Input
					value={state.bvn}
					onChange={(e) => setState({ ...state, bvn: e.target.value })}
				/>
			</Modal>

			<Modal
				okText="Create Investment"
				title="Create Investment"
				onOk={submitCreateInvestment}
				visible={visibleCreateInvestment}
				onCancel={() => setVisibleCreateInvestment(false)}
			>
				<p>Title</p>
				<Input
					value={createState.title}
					onChange={(e) =>
						setCreateState({ ...createState, title: e.target.value })
					}
				/>
				<p>Amount</p>

				{createState.amount === 0 ||
				createState.amount >= settings.minInvestmentAmountInUSD ? null : (
					<p
						style={{
							fontSize: '10px',
							color: 'red',
						}}
					>
						{' '}
						Min Investment amount: {settings.minInvestmentAmountInUSD} USD
					</p>
				)}

				<Input
					value={createState.amount}
					onChange={(e) =>
						setCreateState({ ...createState, amount: Number(e.target.value) })
					}
				/>
				<p>Investment Form</p>
				<Select
					defaultValue={createState.investmentForm}
					style={{ width: '100%' }}
					onChange={(value) =>
						setCreateState({ ...createState, investmentForm: value })
					}
				>
					{investForm.map((i: any) => (
						<Select.Option key={i.key} value={i.key}>
							{i.label}
						</Select.Option>
					))}
				</Select>

				{/* <p>Duration In Month</p>
				<Select
					defaultValue={createState.durationInMonth}
					style={{ width: '100%' }}
					onChange={(value) =>
						setCreateState({ ...createState, durationInMonth: value })
					}
				>
					{duration.map((i: any) => (
						<Select.Option key={i.key} value={i.key}>
							{i.label}
						</Select.Option>
					))}
				</Select> */}
				{createState.investmentForm === 'REAL_ESTATE' && (
					<>
						<p>Duration In Month</p>
						<Select
							defaultValue={createState.durationInMonth}
							style={{ width: '100%' }}
							onChange={(value) =>
								setCreateState({ ...createState, durationInMonth: value })
							}
						>
							{duration.map((i: any) => (
								<Select.Option key={i.key} value={i.key}>
									{i.label}
								</Select.Option>
							))}
						</Select>
					</>
				)}

				<p>ReInvest After Maturity</p>
				<Select
					defaultValue={createState.reInvestAfterMaturity}
					style={{ width: '100%' }}
					onChange={(value) =>
						setCreateState({
							...createState,
							reInvestAfterMaturity: Boolean(value),
						})
					}
				>
					{reInvest.map((i: any) => (
						<Select.Option key={i.key} value={i.key}>
							{i.label}
						</Select.Option>
					))}
				</Select>

				<p>Currency</p>
				<Select
					defaultValue={createState.currencyId}
					style={{ width: '100%' }}
					onChange={(value) =>
						setCreateState({ ...createState, currencyId: value })
					}
				>
					{currencies
						.filter((i: any) => i.useInvestment)
						.map((i: any) => (
							<Select.Option key={i._id} value={i._id}>
								{i.symbol}
							</Select.Option>
						))}
				</Select>
			</Modal>
		</Style>
	);
};

export default Investment;
